export enum Scopes {
  Company = 'employer:company',
  Directory = 'employer:directory',
  Individual = 'employer:individual',
  Employment = 'employer:employment',
  Payment = 'employer:payment',
  Pay_Statement = 'employer:pay_statement',
  Ssn = 'employer:ssn',
  Benefits = 'employer:benefits',
  Plans = 'employer:plans',
  Plans_Enrollments = 'employer:plans_enrollments',
  Plans_Dependents = 'employer:plans_dependents',
}
